import cx from 'clsx';
import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import useTranslation from '@hooks/useTranslation';

import type { IEquipmentDetails } from '@model/equipmentDetails';

import EquipmentAssociatedSkeleton from './EquipmentAssociatedSkeleton';
import style from './style.module.scss';

interface IProps {
  detailsData?: IEquipmentDetails;
  isEquipmentLoading?: boolean;
}

const EquipmentAssociated: React.FC<IProps> = ({ detailsData, isEquipmentLoading }) => {
  const { t } = useTranslation();
  const { customerId } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const equipment = detailsData?.equipment;

  return (
    <>
      <div className={style.blockTitle}>{t('Associated equipment')}</div>
      <div className={style.blockContainer}>
        <table className={style.equipmentTable} cellSpacing="0" cellPadding="0">
          <thead>
            <tr>
              <th>{t('Equipment')}</th>
              <th>{t('Asset code')}</th>
            </tr>
          </thead>
          <tbody>
            {isEquipmentLoading ? (
              <EquipmentAssociatedSkeleton />
            ) : (
              <tr>
                <td
                  className={style.cellEquipmentName}
                  onClick={() =>
                    navigate(`/customer/${customerId}/sensors/${equipment?.id}/list`, {
                      state: { prevPage: pathname },
                    })
                  }
                >
                  {equipment?.name}
                </td>
                <td>{equipment?.asset_code}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default EquipmentAssociated;
